<template>

  <div id="introduction" class="section">
    <div class="introduction_content">
    <div class="introduction_vertical">

      <img src="../assets/jack.svg">

    </div>

    <div class="intro_image"></div>

    <div class="introduction_title">
    <h1>Introduction</h1>
    </div>

    <div class="introduction_text">
      <div class="intoroduction_text_in">
        <p>
        近年、ドキュメンタリー映画を作り続けてきた堀江実監督は<br class="norm_br">
        長引くコロナ禍の現状に触発されて、「映画を作り、生きる」という<br  class="norm_br">
        自身の根本を問い直す劇映画の制作を決意する。<br class="norm_br">
        モノローグと風景の結びつきを要とした<br class="norm_br">
        ヤマザキアキラによるオリジナルシナリオを踏まえ、<br class="norm_br">
        野沢徹役に札幌を拠点に俳優・ナレーターとして活動する小林エレキ、<br class="norm_br">
        松井ミカ役にシンガーソングライターの白波多カミンを起用。<br class="norm_br">
        ふたりに似合う等身大の街並みとして、<br class="norm_br">
        監督自身とも馴染み深い東中野・高円寺・雑司ヶ谷・南砂町といった<br class="norm_br">
        東京の風景が採用されていく。<br class="norm_br">
        2022年の初夏、本作の核心となる海辺での8ミリフィルム撮影よりクランクイン。<br class="norm_br">
        メインカメラマンは、フジファブリックのMVや、<br class="norm_br">
        現代美術家・村上隆の創作活動を長期に渡り記録しているヨシダシゲル。<br class="norm_br">
        音楽は、本作出演の白波多カミンに加え、<br class="norm_br">
        劇団・快快『コーリングユー』(22)での活躍も記憶に新しい<br class="norm_br">
        テンテンコが初めての映画音楽を手掛けた。<br class="norm_br">
        </p>
      </div>

      </div>
    </div>

  </div>
</template>

<style>

  #introduction{
  /* border: 1px dashed rgb(1, 60, 10);  */
  position: relative;
  justify-content: center;
  align-items: center;
  width:100%;

}

.introduction_content{
  position: static;
  /* border: 1px solid rgb(8, 12, 228);  */
  width:100%;
  text-align: left;
  padding: 0px;
  padding-top: 10vh;

}

.introduction_vertical{
  /* border: 2px dashed rgb(235, 5, 5);   */
  align-items: center;
  justify-content: center;
  display: flex;
  margin-top: 0vh;
  margin-bottom: 10vh;
  padding-top: 10vh;
}

.introduction_text{
  /* border: 1px dashed rgb(235, 223, 5);   */
  position: static;
  display: flex;
  justify-content: center;

  width:100%;
  height:auto;
  
  padding-left: 0vw;
  padding-bottom: 5vw;
  /* text-align: center; */

}
.intoroduction_text_in{
  /* border: 1px dashed rgb(158, 5, 235);   */
  width: 70%;
  margin-top: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size:14px;
}

.intoroduction_text_in p{
  /* border: 1px dashed rgb(235, 5, 70);  */
  font-family: 'Shippori Mincho', sans-serif;
  text-align: justify;
  /* color: rgb(97, 13, 224); */
  /* white-space: nowrap; */
  line-height: 1.8;
  letter-spacing: 2px;
  word-break: break-all;
  margin: 0;
  margin-bottom: 3vh;
}

.introduction_title{
/* border: 1px dashed rgb(5, 5, 215);  */
font-family: 'Shippori Mincho', sans-serif;
display: flex;
text-align: center;
justify-content: center;
margin-top: 1vh;
}

.introduction_title h1{
  /* border: 1px dashed rgb(5, 20, 235);   */
  line-height: 0.8;
  font-size:32px;
}


.intro_image{
  /* border: 1px dashed rgb(1, 60, 10);  */
  display: flex;
  width:100%;
  height:344px;
  background-image: url('../assets/Introduction.jpg');
  background-size:contain; 
  align-items: center;
  background-repeat: no-repeat;
  background-position: center;
}

/* iPhone 縦 */
@media screen and (min-width:390px) { 
    /*for iPhone Landscape(iPhone 横)*/
  .norm_br{
    display: none;
  }
  .intoroduction_text_in p{
    text-align: left;
    text-align: justify;
  }

}
@media screen and (min-width:391px) and ( max-width:1023px) {
    /*for iPad */
  .norm_br{
    display: block;
  }



}
@media screen and (min-width:1024px) {
    /*for PC*/
    .norm_br{
    display: block;

  }
  .intoroduction_text_in p{
    text-align: center;
  }

}



</style>